<template>
  <div
    v-if="showSidebar"
    class="hidden md:block min-h-full flex w-[80px] bg-[#1f264c] top-0 left-0 flex-col space-y-1 p-1"
  >
    <template v-for="item in items">
      <router-link
        v-if="item.featureFlagOn"
        v-slot="{ navigate, isActive }"
        :key="item.id"
        :to="{ name: item.name }"
        :data-testid="item.name"
        exact
      >
        <NavItem
          class="text-center p-2 px-1 rounded text-xs relative flex flex-col items-center justify-center z-20"
          :show-chevron="item.nestedItems && hasStudentFulfillmentPermissions(item.nestedItems)?.length > 0"
          :feature-flag-on="item.featureFlagOn"
          :name="getIconDisplayName(item)"
          :icons="item.icons"
          :nested-items="hasStudentFulfillmentPermissions(item.nestedItems)"
          :is-active="isActive"
          @click="navigate"
        />
      </router-link>
    </template>
  </div>
  <div v-else />
</template>

<script>
import { hasStudentFulfillmentPermission } from "@/composables/authorization";
import { sidebarMixin } from "@/mixins/sidebar.js";
import NavItem from "./NavItem";

export default {
  name: "DesktopSideBar",
  components: { NavItem },
  mixins: [sidebarMixin],
  methods: {
    getIconDisplayName: (item) => item?.meta?.displayName || "",
    hasStudentFulfillmentPermissions: (nestedItems) => {
      if (
        !nestedItems ||
        (nestedItems.some((item) => item.name === "Student Fulfillment") && !hasStudentFulfillmentPermission.value)
      ) {
        return [];
      }

      return nestedItems;
    },
  },
};
</script>
